import React from 'react'
import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';

const DismissModal = ({ signal, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [reason, setReason] = React.useState('');
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 440, maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.riskSignals.dismissTitle')}</div>
        <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 16 }}>
          {t('screens.riskSignals.dismissingLabel')} <strong>{signal.title}</strong>
        </div>
        <textarea
          value={reason}
          onChange={e => setReason(e.target.value)}
          placeholder={t('screens.riskSignals.dismissReasonPh')}
          rows={3}
          style={{
            width: '100%',
            padding: '12px 14px',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 13,
            color: S.textPrimary,
            resize: 'vertical',
            outline: 'none',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
          }}
        />
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
          <button
            onClick={onCancel}
            style={{
              padding: '9px 20px',
              background: S.bgCard,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              color: S.textSecondary,
              cursor: 'pointer',
            }}
          >
            {t('screens.riskSignals.cancel')}
          </button>
          <button
            onClick={() => reason.trim() && onConfirm(reason.trim())}
            disabled={!reason.trim()}
            style={{
              padding: '9px 20px',
              background: `linear-gradient(135deg, ${S.burgundy}, #722f37)`,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: reason.trim() ? 'pointer' : 'default',
              opacity: reason.trim() ? 1 : 0.5,
            }}
          >
            {t('screens.riskSignals.actionDismiss')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DismissModal
